<template>
  <section class="success-ladder">
    <div class="success-ladder__wrapper">
      <div class="success-ladder__header_wrapper">
        <video
          muted
          playsinline
          preload="none"
          loop="loop"
          poster="@/assets/img/success-ladder/header-background.png"
          class="success-ladder__video"
          ref="headerVideo"
        >
          <source
            src="@/assets/img/success-ladder/video.mp4"
            type="video/mp4"
          />
        </video>

        <img
          src="@/assets/img/success-ladder/header_shadow.png"
          alt="background"
          class="success-ladder__video"
        />
        <SuccessHeader />
        <div class="success-ladder__header_wall">СТЕНА</div>
        <div class="success-ladder__header_success">УСПЕХА</div>
        <div class="success-ladder__header_text">
          Порадуйтесь за <span>Независимых Партнеров</span>, ставших частью
          успеха бизнеса <span>Herbalife</span>! Разделите вместе с нами радость
          новых <span>квалификаций и достижений</span>!
        </div>
      </div>
      <div class="success-ladder__footer_wrapper">
        <div class="success-ladder__title">Выберите вашу категорию</div>
        <div class="success-ladder__list">
          <div
            v-for="(category, index) in activeCategories"
            :key="index"
            class="success-ladder__item"
            @click="categoryDetails(category)"
          >
            <img
              :src="category.image"
              alt=""
              class="success-ladder__item_img"
            />
            <div class="success-ladder__item_text">{{ category.name }}</div>
          </div>
        </div>
        <div class="success-ladder__title success-ladder__books-title">
          Книга успеха
        </div>
        <div class="success-ladder__books">
          <div
            class="success-ladder__book"
            @click="
              bookClick(
                'Herbalife Recognition Book 2019',
                'https://cld.bz/0Z9kqMp'
              )
            "
          >
            <div class="success-ladder__book-image">
              <img
                :src="require('@/assets/img/success-ladder/books/2019.jpg')"
              />
            </div>
            <div class="success-ladder__book-text">2019 г.</div>
          </div>
          <div
            class="success-ladder__book"
            @click="
              bookClick(
                'Recognition Book 2020 - digital',
                'https://cld.bz/nuzAoZt'
              )
            "
          >
            <div class="success-ladder__book-image">
              <img
                :src="require('@/assets/img/success-ladder/books/2020.jpg')"
              />
            </div>
            <div class="success-ladder__book-text">2020 г.</div>
          </div>
          <div
            class="success-ladder__book"
            @click="
              bookClick(
                'Recognition Book 2021',
                'https://nam10.safelinks.protection.outlook.com/?url=https%3A%2F%2Fcld.bz%2FPcpWEGo&data=04%7C01%7Cartemeva%40herbalife.com%7C23f967a3320e4d2142f408d9e7d4f77f%7C101f87a76d6b4c6c9d9c223592a2ba50%7C0%7C0%7C637795724131822019%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000&sdata=DTZkud4%2B8tVf5ojaCScFZd%2BQtqKb2C3liT1ckJEXU8o%3D&reserved=0'
              )
            "
          >
            <div class="success-ladder__book-image">
              <img
                :src="require('@/assets/img/success-ladder/books/2021.jpg')"
              />
            </div>
            <div class="success-ladder__book-text">2021 г.</div>
          </div>
          <div
            class="success-ladder__book"
            @click="
              bookClick('Recognition Book 2022', 'https://cld.bz/0EDG8Tu/14/')
            "
          >
            <div class="success-ladder__book-image">
              <img
                :src="require('@/assets/img/success-ladder/books/2022.jpg')"
              />
            </div>
            <div class="success-ladder__book-text">2022 г.</div>
          </div>
        </div>
        <div class="success-ladder__title">
          Founder's Circle & Chairman's Club
        </div>
        <div class="success-ladder__list success-ladder__list-flex">
          <div
            v-for="(category, index) in additionalCategories"
            :key="index"
            class="success-ladder__item"
            @click="toChairmansSection(category)"
          >
            <img
              :src="category.image"
              alt=""
              class="success-ladder__item_img"
            />
            <div class="success-ladder__item_text">{{ category.name }}</div>
          </div>
        </div>
        <SuccessFooter />
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Trans } from "@/plugins/translation";
import SuccessFooter from "@/components/success-ladder/SuccesFooter.vue";
import SuccessHeader from "@/components/success-ladder/SuccessHeader.vue";

export default {
  metaInfo() {
    return { title: "Стена успеха" };
  },
  name: "SuccesLadder",
  components: { SuccessHeader, SuccessFooter },
  data() {
    return {};
  },
  async mounted() {
    await this.getAllCategories();

    // Автоматически запустить видео только когда оно попало в область видимости
    const video = this.$el.querySelector('.success-ladder__video'); // ищем твой header video
    if (video) {
      video.removeAttribute('autoplay'); // на всякий случай убираем, если остался
      

      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.1 });

      observer.observe(video);
    }
  },
  computed: {
    ...mapGetters(["categories"]),
    currentLocale() {
      return Trans.currentLocale.trim();
    },
    activeCategories() {
      let arr = new Array();
      if (this.categories) {
        this.categories
          .filter((el) => el.slug !== "chairmans-club")
          .forEach((el) => {
            if (el.active) {
              arr.push(el);
            }
          });
      }
      return arr;
    },
    additionalCategories() {
      return this.categories.filter((el) => el.slug === "chairmans-club");
    },
  },
  methods: {
    ...mapActions(["getAllCategories"]),
    categoryDetails(item) {
      this.$router.push({
        name: "SuccessCategory",
        params: {
          locale: this.currentLocale,
          id: item.id,
          selectedYear: { text: "Год", value: "" },
          selectedMonth: { text: "Месяц", value: "" },
        },
      });
      if (this.$gtm) {
        this.$gtm.push({
          event: "wall_category",
          param_value: this.helpers.stripHtml(item.name),
        });
      }
    },
    toChairmansSection(item) {
      this.$router.push({
        name: "ChairmansClub",
      });
      if (this.$gtm) {
        this.$gtm.push({
          event: "wall_category",
          param_value: this.helpers.stripHtml(item.name),
        });
      }
    },
    bookClick(txt, link) {
      if (this.$gtm) {
        this.$gtm.push({
          event: "wall_leader_book",
          param_value: this.helpers.stripHtml(txt),
        });
      }
      window.open(link);
    },
  },
  watch: {},
};
</script>

<style scoped>
.success-ladder__video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.success-ladder {
  position: relative;
  display: block;
  width: 100%;
  min-height: 100vh;
  background: #0e0e0e;
  font-family: "Jost", sans-serif;
  font-style: normal;
  font-weight: normal;
  color: #ffffff;
}
.success-ladder__wrapper {
  position: relative;
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto;
}
.success-ladder__header_wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("~@/assets/img/success-ladder/header-background.png");
  background-position: center;
  background-size: cover;
  padding-top: 48px;
  padding-bottom: 156px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.success-ladder__footer_wrapper {
  position: relative;
  width: 100%;
  height: auto;
  padding: 45px 135px 0px 135px;
  box-sizing: border-box;
}
.success-ladder__footer_wrapper::after {
  position: absolute;
  display: block;
  content: "";
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: url("~@/assets/img/success-ladder/BG-transparent.png") fixed;
  background-position: center;
  background-size: contain;
  opacity: 0.7;
}
.success-ladder__header_wall {
  position: relative;
  margin-top: 117px;
  font-family: "Noto-Sans";
  font-style: normal;
  font-weight: normal;
  font-size: 120px;
  line-height: 140px;
  text-align: center;
  color: #ecd493;
  text-transform: uppercase;
}
/* .success-ladder__header_wrapper::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 5;
    background: linear-gradient(180deg, rgba(14,14,14,0) 0%, rgba(14,14,14,0) 90%, rgba(14,14,14,1) 98%, rgba(14,14,14,1) 100%);
  }
  .success-ladder__footer_wrapper::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 5;
    background: linear-gradient(0deg, rgba(14,14,14,0) 0%, rgba(14,14,14,0) 95%, rgba(14,14,14,1) 99%, rgba(14,14,14,1) 100%);
  } */
.success-ladder__header_success {
  position: relative;
  font-family: "Noto-Sans";
  font-style: normal;
  font-weight: bold;
  font-size: 152px;
  line-height: 178px;
  text-align: center;
  color: #ecd493;
  text-transform: uppercase;
}
.success-ladder__header_text {
  position: relative;
  display: block;
  margin-top: 55px;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  width: 512px;
}
.success-ladder__header_text span {
  font-family: "Marion";
  font-style: italic;
  font-weight: normal;
  font-size: 20px;
  line-height: 30px;
  color: #ecd593;
}
.success-ladder__title {
  font-size: 36px;
  line-height: 52px;
  text-align: center;
}
.success-ladder__list {
  position: relative;
  margin: 90px auto;
  max-width: 1100px;
  justify-content: center;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 60px;
  row-gap: 60px;
}

.success-ladder__list-flex {
  display: flex;
  width: auto;
}
.success-ladder__books {
  position: relative;
  z-index: 10;
  margin: 0 auto 90px;
  max-width: 1100px;
  justify-content: center;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 60px;
  row-gap: 60px;
}
.success-ladder__books-title {
  margin-bottom: 72px;
}
.success-ladder__book {
  display: flex;
  cursor: pointer;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.success-ladder__book-image {
  position: relative;
}
.success-ladder__book-image::before {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    0deg,
    rgba(252, 203, 78, 0.07),
    rgba(252, 203, 78, 0.07)
  );
  opacity: 0;
  transition: 0.3s;
  content: "";
}
.success-ladder__book-image:hover::before {
  opacity: 1;
}
.success-ladder__book-text {
  margin-top: 50px;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 35px;
  text-align: center;
  letter-spacing: 0.04em;
  color: #ffffff;
}
.success-ladder__item {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 6;
  cursor: pointer;
}
.success-ladder__item_img {
  width: 200px;
  height: 200px;
  object-position: center;
  object-fit: cover;
}
.success-ladder__item_text {
  width: 100%;
  margin-top: 48px;
  font-size: 24px;
  line-height: 35px;
  text-align: center;
}

@media screen and (max-width: 1540px) {
  .success-ladder__video {
    background-size: cover;
    background-position: 50% 50%;
    position: absolute;
    margin: auto;
    width: 100%;
    height: 100%;
    right: -100%;
    bottom: -100%;
    top: -100%;
    left: -100%;
    object-fit: cover;
  }
}

@media screen and (max-width: 1220px) {
  .success-ladder__video {
    background-size: cover;
    background-position: 50% 50%;
    position: absolute;
    margin: auto;
    width: 100%;
    height: 100%;
    right: -100%;
    bottom: -100%;
    top: -100%;
    left: -100%;
    object-fit: cover;
  }
  .success-ladder__wrapper {
    width: 100%;
  }
  .success-ladder__header_wrapper {
    padding-top: 30px;
    padding-bottom: 185px;
  }
  .success-ladder__header_wall {
    margin-top: 158px;
  }
  .success-ladder__header_text {
    margin-top: 74px;
    width: 482px;
  }
  .success-ladder__footer_wrapper {
    padding: 64px 90px 0px 90px;
  }
  .success-ladder__list {
    margin-top: 84px;
    width: 100%;
    grid-template-columns: repeat(2, 200px);
    column-gap: unset;
    justify-content: space-between;
  }
  .success-ladder__books {
    width: 100%;
    grid-template-columns: repeat(2, 200px);
    column-gap: unset;
    justify-content: space-between;
  }
}

@media screen and (max-width: 743px) {
  .success-ladder__header_wrapper {
    height: auto;
    padding: 56px 40px 150px;
  }
  .success-ladder__header_wall {
    margin-top: 113px;
    font-size: 60px;
    line-height: 70px;
  }
  .success-ladder__header_success {
    font-size: 76px;
    line-height: 89px;
  }
  .success-ladder__header_text {
    margin-top: 38px;
    width: 100%;
    font-size: 14px;
    line-height: 18px;
  }
  .success-ladder__header_text span {
    font-size: 14px;
    line-height: 18px;
  }
  .success-ladder__footer_wrapper {
    padding: 100px 26px 0px;
  }
  .success-ladder__list {
    margin-top: 84px;
    width: 100%;
    grid-template-columns: repeat(1, 1fr);
  }
  .success-ladder__books {
    margin-top: 84px;
    width: 100%;
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
